import React from "react";
import { Box } from "@material-ui/core";
import AppSwitchComponent from "../../../components/form/app-switch";

const SwitchComponent = () => {
  return (
    <Box style={{ display: "grid", gap: "1.5rem", padding: "0 40px" }}>
      <Box className="d-flex align-items-center" style={{ gap: "1.5rem" }}>
        <AppSwitchComponent label="Small Switch" size="small" />
        <AppSwitchComponent label="Medium Switch" size="medium" />
      </Box>
      <Box className="d-flex align-items-center" style={{ gap: "1.5rem" }}>
        <AppSwitchComponent
          label="Primary Switch"
          size="medium"
          color="primary"
        />

        <AppSwitchComponent
          label="Secondary Switch"
          size="medium"
          color="secondary"
        />
        <AppSwitchComponent
          label="Disabled Switch"
          size="medium"
          color="primary"
          disabled
        />
      </Box>
      <Box className="d-flex align-items-center" style={{ gap: "1.5rem" }}>
        <AppSwitchComponent
          label="Switch at start"
          size="medium"
          color="primary"
          labelPlacement="start"
        />

        <AppSwitchComponent
          label="Switch at end"
          size="medium"
          color="primary"
          labelPlacement="end"
        />
        <AppSwitchComponent
          label="Switch at top"
          size="medium"
          color="primary"
          labelPlacement="top"
        />
        <AppSwitchComponent
          label="Switch at bottom"
          size="medium"
          color="primary"
          labelPlacement="bottom"
        />
      </Box>
    </Box>
  );
};

export default SwitchComponent;
